/*
 * Angular 2 decorators and services
 */
import { Component, ViewEncapsulation } from '@angular/core';
import { environment } from 'environments/environment';

/*
 * App Component
 * Top Level Component
 */
@Component({
  selector: 'app',
  encapsulation: ViewEncapsulation.None,
  styleUrls: [
    './scss/application.scss',
  ],
  template: '<simple-notifications [options]="toasteroptions"></simple-notifications><router-outlet></router-outlet>'
})
export class App {
  public toasteroptions = {
    position: ["top", "right"],
    timeOut: 5000,
    showProgressBar: false,
    lastOnBottom: false
};

  constructor(){
    console.warn("AppVersion", environment.version);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts